import type { PatientInfo, ReportSectionData } from '../types';

export const generateReportSummary = async (patientInfo: PatientInfo, reportData: ReportSectionData[], language: string): Promise<string> => {
  try {
    const response = await fetch('/.netlify/functions/generate-summary', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ patientInfo, reportData, language }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Request failed with status ${response.status}`);
    }

    const data = await response.json();
    return data.summary;

  } catch (error) {
    console.error("Error generating report summary:", error);
    if (error instanceof Error) {
        return `An error occurred while analyzing the report: ${error.message}. Please try again.`;
    }
    return "An unknown error occurred while analyzing the report.";
  }
};